import type React from 'react';

import { Button } from 'library/components/common';

import * as st from './styles.module.scss';

export const TechService: React.FC = () => {
	return (
		<div className={st.root}>
			<p>На сайте идут технические работы</p>
			<p>Попробуйте перезагрузить страницу через несколько минут</p>

			<Button handler={() => (window.location.href = '/')}>На главную</Button>
		</div>
	);
};
